import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { Location } from 'models/locations';
import Booking from 'models/booking';
import Event from 'models/event';
import Brand from 'models/brand';
import Review from 'models/review';

import ParkingPass from 'components/bookings/buttons/parking-pass';
import ParkingTimes from 'components/bookings/parking-times';
import RateLocation from 'components/bookings/rate-location';
import Price from 'components/bookings/price';
import Image from 'components/bookings/past/past-booking-modal/image';
import PassNumber from 'components/bookings/past/past-booking-modal/pass-number';
import ReceiptNumber from 'components/bookings/past/past-booking-modal/receipt-number';
import PurchaseDate from 'components/bookings/past/past-booking-modal/purchase-date';

const propTypes = {
  location: PropTypes.instanceOf(Location).isRequired,
  booking: PropTypes.instanceOf(Booking).isRequired,
  brand: PropTypes.instanceOf(Brand).isRequired,
  event: PropTypes.instanceOf(Event),
  className: PropTypes.string,
  review: PropTypes.instanceOf(Review),
  reviewBooking: PropTypes.func.isRequired,
};

const defaultProps = {
  event: null,
  className: '',
  review: null,
};

class PastBookingModal extends Component {
  renderParkingTimes() {
    if (this.props.booking.type === 'monthly_booking') {
      return this.renderMonthlyStartDate();
    }

    return <ParkingTimes booking={this.props.booking} className="text-size-12" labelClassname="text-size-12 text-weight-book" />;
  }

  renderMonthlyStartDate() {
    const { booking } = this.props;

    return (
      <div className="parking-times">
        <div className="row horizontal-padding">
          <div className="arrival col-xs-5">Starts</div>
          <div className="col-xs-7 padding-0">
            <span className="weak">{booking.startTime.format('ddd MMM D ')}</span>
          </div>
        </div>
      </div>
    );
  }

  renderParkingInfo() {
    const { booking, event } = this.props;
    if (booking.isMonthly) {
      const monthlyName = booking.monthlyPricing && booking.monthlyPricing.name ? booking.monthlyPricing.name : 'MONTHLY PARKING PASS';

      return <div className="parking-info wrap-ellipses">{monthlyName}</div>;
    } else if (event) {
      return <div className="parking-info wrap-ellipses weak">{event.name}</div>;
    }

    return <div className="parking-info wrap-ellipses" />;
  }

  render() {
    const { booking, location, className, brand, review, reviewBooking } = this.props;

    const cardClasses = cx({
      'active-booking': true,
      'heavy-shadowed': true,
      'padding-bottom-30': booking.onDemand,
    });

    const priceClasses = booking.onDemand ? 'text-size-28 text-weight-book' : 'text-size-14 text-weight-book';

    return (
      <div className={`col-md-4 col-sm-6 col-xs-12 ${className}`}>
        <div className={cardClasses}>
          <div className="booking-row">
            <Image location={location} booking={booking} />
          </div>
          {this.renderParkingInfo()}
          <div className="booking-row horizontal-padding">
            {this.renderParkingTimes()}
          </div>
          <div className="booking-row align-center horizontal-padding">
            <Price
              booking={booking}
              location={location}
              type="paid"
              className={priceClasses}
            />
            <PurchaseDate booking={booking} />
            <ReceiptNumber booking={booking} />
          </div>
          <div className="booking-row align-center horizontal-padding">
            <RateLocation booking={booking} review={review} reviewBooking={reviewBooking} />
          </div>
          <PassNumber booking={booking} />
        </div>
        <ParkingPass
          booking={booking}
          brand={brand}
          useAnchorElement
        />
      </div>
    );
  }
}

PastBookingModal.propTypes = propTypes;
PastBookingModal.defaultProps = defaultProps;

export default PastBookingModal;
